/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Demophysik10Inputs */

const en__field_enum_demophysik10 = /** @type {(inputs: _Field_Enum_Demophysik10Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`13 - Physik`)
};

const de__field_enum_demophysik10 = /** @type {(inputs: _Field_Enum_Demophysik10Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`13 - Physik`)
};

/**
* | output |
* | --- |
* | "13 - Physik" |
*
* @param {_Field_Enum_Demophysik10Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_demophysik10 = /** @type {((inputs?: _Field_Enum_Demophysik10Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Demophysik10Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_demophysik10(inputs)
	return de__field_enum_demophysik10(inputs)
});
export { _field_enum_demophysik10 as "_field_enum_DEMOPHYSIK" }